import styled from 'styled-components';

import { StyledFilterDrawer } from '@components/views/components/listing/drawer/ResponsiveListingFilterAndSortStyle';
import { Col } from '@components/formStyles';

export const FilterWrapper = styled.div`
  width: inherit;
  min-width: 280px;
  background-color: ${({ theme }) => theme.palette.white};
`;

export const StyledFlightFilterDrawer = styled(StyledFilterDrawer)`
  .setur-drawer-content-wrapper {
    height: 100% !important;
  }

  .setur-drawer-header {
    height: 60px;
    padding: 18px 16px;
    background: ${({ theme }) => theme.palette.grey1100};

    .setur-drawer-header-title {
      flex-direction: row-reverse;

      .setur-drawer-title {
        color: ${({ theme }) => theme.palette.white};
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        margin: 0px;
        text-align: left;
      }
    }
  }

  .setur-drawer-body {
    margin-bottom: 0px;
    overflow: auto;
    padding: 0px 12px 50px 12px;
  }

  .setur-drawer-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-top: 1px solid ${({ theme }) => theme.palette.grey300};
    background: ${({ theme }) => theme.palette.white};
    padding: 12px;
  }
`;

export const FlightFiltersDesktopContainer = styled(Col)`
  min-width: 320px;
  padding-top: 20px;
`;

export const FlightFilterButtonWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 12px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
  background-color: ${({ theme }) => theme.palette.white};
`;

export const FlightFilterDrawerFooterWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`;
